// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import {translate} from '../../../../shared/services/translation-service';

function handleChange(event) {

    this.onChange(event.target.value);

}

const LabeledInput = ({className, highlightClass, isEditable, value, formatter, label, type = 'text', vsrMessage, ...props}) =>
    <LabeledFormInput
        className={`${className} ${highlightClass}`}
        label={label}
    >
        <EditableField
            isEditable={isEditable}
            value={formatter ? formatter(value) : value}
        >
            <input
                {...props}
                onChange={props::handleChange}
                type={type}
                value={value}
            />
        </EditableField>
        {
            vsrMessage && <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </LabeledFormInput>;

LabeledInput.displayName = 'LabeledInput';
LabeledInput.propTypes = {
    className: PropTypes.string.isRequired,
    formatter: PropTypes.func,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    vsrMessage: PropTypes.string
};

export default LabeledInput;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-input.js